// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"96":"9bcf62b9","97":"5438b9d1","262":"6fd62bf4","268":"406c0820","330":"17b644d0","392":"b15a4b87","401":"8199a68e","568":"f1fd89fb","571":"bce2b56e","580":"7788c5ba","591":"9d0ab09b","629":"9f637551","697":"2cc90a4c","737":"af4d2152","844":"dc4110aa"}[chunkId] + ".js";
};